if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.thb-product-detail');
      if (this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector('.product-images') || this.productWrapper.querySelector('.product-quick-images');
        this.thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
        this.hideVariants = this.productSlider ? this.productSlider.dataset.hideVariants === 'true' : false;
      }
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
      this.markFullySoldOut();

      // Safety net: re-run availability marking on the next frame in case
      // child fieldsets weren't fully parsed when connectedCallback fired
      // (rare custom-element timing edge case).
      if (!this.fieldsets || this.fieldsets.length === 0) {
        requestAnimationFrame(() => {
          this.updateOptions();
          this.updateMasterId();
          this.setDisabled();
          this.markFullySoldOut();
        });
      }

      // Track initial featured media to avoid redundant transitions on non-image variant changes (e.g. size)
      if (this.currentVariant && this.currentVariant.featured_media) {
        this._lastFeaturedMediaId = this.currentVariant.featured_media.id;
      }

    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }
      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.option_keys = [];

      // Seed `this.options` from the first variant so any options with a
      // single value (whose fieldset is intentionally skipped by the Liquid
      // renderer) are still represented at their correct option position.
      // Without this, e.g. `[Color: Black-only, Size: S/M/L]` would yield
      // `this.options = ['S']` and updateMasterId could never find a match
      // against `variant.options[0] === 'Black'`.
      const variants = this.getVariantData();
      let baseOptions = [];
      if (variants && variants.length > 0 && Array.isArray(variants[0].options)) {
        baseOptions = variants[0].options.slice();
      }

      this.fieldsets.forEach((fieldset) => {
        // Determine which option position this fieldset represents. Liquid
        // renders `data-index="option1|option2|option3"` per fieldset.
        const dataIndex = fieldset.dataset.index || '';
        const m = dataIndex.match(/option(\d+)/);
        const position = m ? parseInt(m[1], 10) - 1 : null;

        let value = null;
        let nameAttr = null;
        const select = fieldset.querySelector('select');
        if (select) {
          value = select.value;
          nameAttr = select.name;
        } else if (fieldset.querySelectorAll('input').length) {
          const checkedInput = fieldset.querySelector('input:checked');
          if (checkedInput) {
            value = checkedInput.value;
            nameAttr = fieldset.querySelector('input').name;
          }
        }

        if (value !== null) {
          if (position !== null && position >= 0) {
            baseOptions[position] = value;
          } else {
            baseOptions.push(value);
          }
          if (nameAttr) this.option_keys.push(nameAttr);
        }
      });

      this.options = baseOptions;
      this.dataset.options = this.options;
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (!fieldsets_array[i]) return;
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            let input = fieldsets_array[i].querySelector(`input[value="${CSS.escape(option)}"]`);
            if (input) input.checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
      this.updateStickyVariantInfo();
    }
    updateStickyVariantInfo() {
      const stickyInfo = document.querySelector('.product-add-to-cart-sticky--variant-info');
      if (!stickyInfo || !this.currentVariant) return;
      const variant = this.currentVariant;
      const product_options = this.closest('variant-selects') ? this.querySelectorAll('fieldset') : [];
      let tagsHTML = '';
      this.fieldsets.forEach((fieldset, i) => {
        const legend = fieldset.querySelector('legend, .form__label');
        const optionName = legend ? legend.textContent.toLowerCase().trim() : '';
        const value = this.options[i];
        if (!value) return;
        if (optionName.includes('color') || optionName.includes('colour')) {
          const colorHandle = value.toLowerCase().replace(/[^a-z0-9]/g, '');
          tagsHTML += `<span class="variant-tag"><span class="variant-tag--color" style="background-color: ${colorHandle};"></span>${value}</span>`;
        } else if (optionName.includes('size')) {
          tagsHTML += `<span class="variant-tag">${value}</span>`;
        }
      });
      stickyInfo.innerHTML = tagsHTML;
    }

    /**
     * Parse the variant-media-map JSON to get media ordering and variant assignments.
     */
    getVariantMediaMap() {
      if (this._variantMediaMap) return this._variantMediaMap;
      const mapEl = this.productWrapper
        ? this.productWrapper.querySelector('[id^="VariantMediaMap-"]')
        : document.querySelector('[id^="VariantMediaMap-"]');
      if (mapEl) {
        try {
          this._variantMediaMap = JSON.parse(mapEl.textContent);
        } catch (e) {
          this._variantMediaMap = null;
        }
      }
      return this._variantMediaMap;
    }

    /**
     * Get the range of media IDs to display for the current variant.
     * Uses pre-computed variantRanges from the Liquid template, then appends global images.
     * Returns an array of numeric media IDs, or null if no map available.
     */
    getVariantImageRange() {
      const map = this.getVariantMediaMap();
      if (!map || !this.currentVariant || !this.currentVariant.featured_media) return null;

      const featuredMediaId = Number(this.currentVariant.featured_media.id);

      // Look up the pre-computed range for this variant's featured image
      const variantRanges = map.variantRanges;
      if (!variantRanges || !variantRanges[featuredMediaId]) return null;

      const range = variantRanges[featuredMediaId].map(Number);

      // Append global media IDs (images before the first variant image) at the end
      const globalIds = (map.globalMediaIds || []).map(Number);
      const rangeSet = new Set(range);
      for (const gid of globalIds) {
        if (!rangeSet.has(gid)) {
          range.push(gid);
        }
      }

      return range;
    }

    /**
     * Show the loading spinner overlay.
     */
    showLoader() {
      if (!this.productWrapper) return;
      const loader = this.productWrapper.querySelector('.variant-image-loader');
      if (loader) loader.classList.add('is-loading');
    }

    /**
     * Hide the loading spinner overlay.
     */
    hideLoader() {
      if (!this.productWrapper) return;
      const loader = this.productWrapper.querySelector('.variant-image-loader');
      if (loader) loader.classList.remove('is-loading');
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      // Skip transition if the featured media hasn't changed (e.g., size-only variant change)
      const newFeaturedId = this.currentVariant.featured_media.id;
      if (this._lastFeaturedMediaId === newFeaturedId) return;
      this._lastFeaturedMediaId = newFeaturedId;

      // Lazily resolve slider if not yet available
      if (!this.productSlider && this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector('.product-images') || this.productWrapper.querySelector('.product-quick-images');
        this.thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
        this.hideVariants = this.productSlider ? this.productSlider.dataset.hideVariants === 'true' : false;
      }
      if (!this.productSlider) return;

      let mediaId = `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = this.productSlider.querySelector(mediaId);

      if (!activeMedia) return;

      // Check if Flickity is actually active (it's destroyed on desktop)
      const hasActiveFlickity = typeof Flickity !== 'undefined' && Flickity.data(this.productSlider);

      if (this.thumbnails && hasActiveFlickity) {
        this.setActiveMediaSlider(mediaId, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider);
      } else {
        this.setActiveMedia(activeMedia);
      }

    }

    setActiveMedia(activeMedia) {
      const allSlides = this.productSlider.querySelectorAll('[data-media-id]');
      const sectionId = this.dataset.section;
      const range = this.getVariantImageRange();
      const rangeSet = range ? new Set(range.map(Number)) : null;
      const isDesktop = window.innerWidth > 1068;

      // Show spinner
      this.showLoader();

      // Fade out currently visible slides
      allSlides.forEach((el) => {
        if (el.offsetWidth > 0) {
          el.classList.add('variant-fade-out');
        }
      });

      // After fade-out completes, swap images and fade back in
      setTimeout(() => {
        // Remove all active states
        allSlides.forEach((element) => {
          element.classList.remove('is-active');
          element.classList.remove('variant-range-hidden');
        });

        this.setImageSetMedia();

        if (isDesktop && rangeSet) {
          // Desktop stacked layout: show only images in the variant's range
          allSlides.forEach((el) => {
            const rawId = parseInt(el.dataset.mediaRawId, 10);
            if (rangeSet.has(rawId)) {
              el.classList.add('is-active');
              el.classList.remove('variant-range-hidden');
            } else {
              el.classList.remove('is-active');
              el.classList.add('variant-range-hidden');
            }
          });

          // Reorder DOM to match range array: featured → range → global
          const parent = activeMedia.parentElement;
          const slidesByRawId = new Map();
          allSlides.forEach((el) => {
            slidesByRawId.set(parseInt(el.dataset.mediaRawId, 10), el);
          });
          for (const mid of range) {
            const slide = slidesByRawId.get(mid);
            if (slide) parent.appendChild(slide);
          }
        } else {
          // Mobile or no range data: just show active
          activeMedia.classList.add('is-active');
          activeMedia.parentElement.prepend(activeMedia);
        }

        // Remove fade-out class and add fade-in
        allSlides.forEach((el) => {
          el.classList.remove('variant-fade-out');
          if (el.classList.contains('is-active') || (!el.classList.contains('variant-range-hidden') && isDesktop && !rangeSet)) {
            el.classList.add('variant-fade-in');
          }
        });

        // Trigger lazysizes to re-check newly visible images
        if (typeof lazySizes !== 'undefined') {
          lazySizes.autoSizer.checkElems();
          lazySizes.loader.checkElems();
        } else if (typeof lazysizes !== 'undefined') {
          lazysizes.autoSizer.checkElems();
          lazysizes.loader.checkElems();
        }

        // Hide spinner
        this.hideLoader();

        // Clean up fade-in class after transition
        setTimeout(() => {
          allSlides.forEach((el) => {
            el.classList.remove('variant-fade-in');
          });
        }, 400);

        // Reset horizontal scroll position (mobile)
        if (!this.sticky && !isDesktop) {
          this.productSlider.scrollTo({
            left: 0,
            behavior: 'instant'
          });
        }

        // Update pagination if on mobile
        if (!isDesktop) {
          setTimeout(() => {
            const productSliderEl = this.productSlider.querySelector('product-slider');
            if (productSliderEl && productSliderEl.onPaginationResize) {
              productSliderEl.onPaginationResize();
            }
          }, 100);
        }
      }, 350); // match the fade-out duration
    }

    setActiveMediaSlider(mediaId, thumbId, productSlider) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);

      if (!activeMedia) return;

      const range = this.getVariantImageRange();
      const rangeSet = range ? new Set(range.map(Number)) : null;
      const sectionId = this.dataset.section;
      const allSlides = productSlider.querySelectorAll('.product-images__slide');
      const allThumbs = this.thumbnails ? this.thumbnails.querySelectorAll('.product-thumbnail') : [];

      // Show spinner + fade out
      this.showLoader();
      allSlides.forEach((el) => {
        if (el.offsetWidth > 0) el.classList.add('variant-fade-out');
      });

      setTimeout(() => {
        if (flkty && rangeSet) {
          if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
            productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
          }

          // Show only slides in the variant's range, hide all others
          allSlides.forEach((el) => {
            const rawId = parseInt(el.dataset.mediaRawId, 10);
            el.classList.remove('variant-range-hidden');
            if (rangeSet.has(rawId)) {
              el.classList.add('is-active');
            } else {
              el.classList.remove('is-active');
            }
          });

          activeMedia.classList.add('is-initial-selected');

          this.setImageSetMedia();

          // Reorder slides to match range order: featured → range → global
          const slidesByRawId = new Map();
          allSlides.forEach((el) => {
            slidesByRawId.set(parseInt(el.dataset.mediaRawId, 10), el);
          });
          for (const mid of range.map(Number)) {
            const slide = slidesByRawId.get(mid);
            if (slide) productSlider.appendChild(slide);
          }

          if (this.thumbnails) {
            let activeThumb = this.thumbnails.querySelector(thumbId);

            if (this.thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
              this.thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
            }

            // Show matching thumbnails in range, hide all others
            allThumbs.forEach((thumb) => {
              const thumbMediaId = thumb.id.replace(`Thumb-${sectionId}-`, '');
              const rawId = parseInt(thumbMediaId, 10);
              if (rangeSet.has(rawId)) {
                thumb.classList.add('is-active');
              } else {
                thumb.classList.remove('is-active');
              }
            });

            // Reorder thumbnails to match range order
            const thumbsByRawId = new Map();
            allThumbs.forEach((thumb) => {
              const thumbMediaId = parseInt(thumb.id.replace(`Thumb-${sectionId}-`, ''), 10);
              thumbsByRawId.set(thumbMediaId, thumb);
            });
            for (const mid of range.map(Number)) {
              const thumb = thumbsByRawId.get(mid);
              if (thumb) this.thumbnails.appendChild(thumb);
            }

            if (activeThumb) {
              activeThumb.classList.add('is-active');
              activeThumb.classList.add('is-initial-selected');
            }
          }

          productSlider.reInit(this.imageSetIndex);
          productSlider.selectCell(mediaId);

        } else if (flkty) {
          productSlider.selectCell(mediaId);
        } else if (productSlider.flkty) {
          productSlider.flkty.selectCell(mediaId);
        }

        // Update thumbnail selection (no scroll-into-view)
        if (this.thumbnails) {
          let activeThumb = this.thumbnails.querySelector(thumbId);
          if (activeThumb) {
            this.thumbnails.querySelectorAll('.product-thumbnail.is-initial-selected').forEach(el => {
              el.classList.remove('is-initial-selected');
            });
            activeThumb.classList.add('is-initial-selected');
          }
        }

        // Remove fade-out and add fade-in
        allSlides.forEach((el) => {
          el.classList.remove('variant-fade-out');
          if (el.classList.contains('is-active')) {
            el.classList.add('variant-fade-in');
          }
        });

        // Hide spinner
        this.hideLoader();

        // Clean up fade-in class
        setTimeout(() => {
          allSlides.forEach((el) => {
            el.classList.remove('variant-fade-in');
          });
        }, 400);
      }, 350); // match fade-out duration
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        })
        .catch((error) => {
          // Silently handle fetch failure - variant info will remain as-is
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) {
            submitButtonText.textContent = text;
            submitButton.classList.add('sold-out');
          }
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');
          submitButton.classList.remove('sold-out');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      // Note: previously gated by `this.isDisabledFeature !== 'true'`.
      // Removed because the gate could silently skip OOS marking on products
      // where the section setting wasn't explicitly true. We always want
      // unavailable variants to show as crossed-out on DapperFam.
      const variant_data = this.getVariantData();


      if (variant_data) {
        let selected_options = false;
        if (this.currentVariant) {
          selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
        } else {
          let found_option = variant_data.find(option => {
            return option.option1 === this.options[0];
          });
          if (found_option) {
            selected_options = [
              {
                "value": this.options[0],
                "index": "option1"
              },
              {
                "value": found_option.option2,
                "index": "option2"
              }
            ];
          } else {
            return;
          }
        }

        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        this.fieldsets.forEach((fieldset, i) => {
          // Look up the option position this fieldset represents from its
          // `data-index` attribute (`option1|option2|option3`) rather than
          // assuming positional alignment with the available_options tree.
          // Singleton options are skipped by Liquid so fieldset index does
          // NOT necessarily equal option position.
          const dataIndex = fieldset.dataset.index || '';
          const positionMatch = dataIndex.match(/option(\d+)/);
          const optionKey = positionMatch ? `option${positionMatch[1]}` : `option${i + 1}`;
          const fieldset_options = available_options[optionKey];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                const optEl = fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']');
                if (optEl) optEl.disabled = !!option.isUnavailable;
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input) => {
                // Match input to its option entry by value rather than by
                // index — DOM order may not match the order entries were
                // pushed into the availability tree.
                const entry = fieldset_options.find(o => o.value === input.value);
                if (entry) input.classList.toggle('is-disabled', !!entry.isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }

    /**
     * Mark color option values that are completely sold out across ALL sizes.
     * Adds 'is-sold-out' class to the radio input so CSS can show a slash.
     * Runs once on connectedCallback (independent of current selection).
     */
    markFullySoldOut() {
      const variant_data = this.getVariantData();
      if (!variant_data) return;

      this.fieldsets.forEach((fieldset, i) => {
        // Only apply to color-type fieldsets
        if (!fieldset.classList.contains('product-form__input--color')) return;

        const optionKey = `option${i + 1}`;
        const inputs = fieldset.querySelectorAll('input[type="radio"]');

        inputs.forEach((input) => {
          const colorValue = input.value;
          // Find ALL variants that have this color value in this option position
          const variantsWithColor = variant_data.filter(v => v[optionKey] === colorValue);
          // Check if every one of those variants is unavailable
          const allSoldOut = variantsWithColor.length > 0 && variantsWithColor.every(v => !v.available);

          input.classList.toggle('is-sold-out', allSoldOut);
        });
      });
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }

    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }
      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productSlider.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        if (this.thumbnails) {
          // Product images
          this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_images.forEach(thumb => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });

          // Product thumbnails
          this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_thumbs.forEach(thumb => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });
        } else {
          // Product images
          this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_images.forEach(thumb => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });
        }

      } else {

        if (!this.thumbnails) {
          let set_images = Array.from(selected_set_images).filter(function (element) {
            return element.dataset.group === group;
          });
          set_images.forEach(thumb => {
            thumb.parentElement.prepend(thumb);
          });
        }

      }
      if (!this.thumbnails) {
        setTimeout(() => {
          this.productSlider.querySelector('product-slider').onPaginationResize();
        }, 100);
      }
    }

    createAvailableOptionsTree(variants, currentlySelectedValues) {
      // Reduce variant array into option availability tree
      return variants.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = { value: variant[index], isUnavailable: true };
            options[index].push(entry);
          }

          const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1');
          const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2');

          switch (index) {
            case 'option1':
              // Option1 inputs should always remain enabled based on all available variants
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              break;
            case 'option2':
              // Option2 inputs should remain enabled based on available variants that match first option group
              if (currentOption1 && variant.option1 === currentOption1.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
              break;
            case 'option3':
              // Option 3 inputs should remain enabled based on available variants that match first and second option group
              if (currentOption1 && variant.option1 === currentOption1.value && currentOption2 && variant.option2 === currentOption2.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
          }
        });

        return options;
      }, { option1: [], option2: [], option3: [] });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
        return checkedRadio ? checkedRadio.value : null;
      }).filter(Boolean);
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      // Start Gallery
      let observer = new MutationObserver(() => {
        this.setupProductGallery();
      });

      observer.observe(this, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: false
      });

      this.setupProductGallery();

      // Start Pagination
      if (this.pagination) {
        this.setupPagination();
        this.resizeObserver = new ResizeObserver(entries => this.onPaginationResize());
        this.resizeObserver.observe(this);
        this.addEventListener('scroll', this.updatePagination.bind(this));
      }
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }

      this.setEventListeners();
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    setEventListeners() {
      let activeImages = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0),
        items = this.buildItems(activeImages),
        captionEl = this.dataset.captions,
        pswpElement = document.querySelectorAll('.pswp')[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true
        };

      let openPswp = function (e, link, options, pswpElement, items) {
        let parent = link.closest('.product-images__slide');
        let i = activeImages.indexOf(parent);
        options.index = parseInt(i, 10);
        options.getThumbBoundsFn = () => {
          const thumbnail = link.closest('.product-single__media'),
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        };
        if (typeof PhotoSwipe !== 'undefined') {
          let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

          pswp.listen('firstUpdate', () => {
            pswp.listen('parseVerticalMargin', function (item) {
              item.vGap = {
                top: 50,
                bottom: 50
              };
            });
          });
          pswp.listen('destroy', () => {
            pswpElement.classList.remove('pswp--open', 'pswp--animate_opacity', 'pswp--notouch', 'pswp--css_animation', 'pswp--svg', 'pswp--animated-in', 'pswp--has_mouse');
            pswpElement.removeAttribute('style');
            // Ensure cleanup survives any post-destroy style reapplication by PhotoSwipe
            setTimeout(() => {
              pswpElement.classList.remove('pswp--open', 'pswp--animate_opacity', 'pswp--notouch', 'pswp--css_animation', 'pswp--svg', 'pswp--animated-in', 'pswp--has_mouse');
              pswpElement.removeAttribute('style');
            }, 400);
          });
          pswp.init();
        }
        e.preventDefault();
      };
      this.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
        let thumbnail = link.closest('.product-single__media');
        let clone = link.cloneNode(true);
        thumbnail.append(clone);
        link.remove();
        clone.addEventListener('click', (e) => openPswp(e, clone, options, pswpElement, items));
      });

      this.video_containers.forEach((container) => {
        const btn = container.querySelector('button');
        if (btn) {
          btn.addEventListener('click', function () {
            container.setAttribute('hidden', '');
          });
        }
      });
    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');

      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');

      if (!this.prevButton || !this.nextButton) return;

      this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));

      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);

      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.updatePagination();
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
    updatePagination() {
      if (!this.nextButton) return;
      if (!this.sliderItemOffset || this.sliderItemOffset === 0) return; // Guard against division by zero

      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.pageTotalElement) {
        this.pageTotalElement.textContent = this.sliderItemsToShow.length;
      }

      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      if (!this.form) return;

      const idInput = this.form.querySelector('[name=id]');
      if (idInput) idInput.disabled = false;

      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      } else {
        // For sticky add-to-cart, intercept the button click to use AJAX submission
        this.stickyButton = this.querySelector('#AddToCartSticky');
        if (this.stickyButton) {
          this.stickyButton.addEventListener('click', this.onStickyButtonClick.bind(this));
        }
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onStickyButtonClick(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      // Trigger the AJAX submission using the main form
      this.onSubmitHandler(evt);
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.form.reportValidity()) {
        return;
      }
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }
        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.querySelector('.product-quick-images--container').classList.remove('active');
        document.body.classList.remove('open-quick-view');

        if (window.innerWidth < 1069) {
          product_drawer.classList.remove('active');
          if (document.getElementById('Cart-Drawer')) {
            document.getElementById('Cart-Drawer').classList.add('active');
            document.body.classList.add('open-cart');
            document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
            dispatchCustomEvent('cart-drawer:open');
          }
        } else {
          product_drawer.querySelector('.product-quick-images--container').addEventListener('transitionend', function () {
            product_drawer.classList.remove('active');

            if (document.getElementById('Cart-Drawer')) {
              document.getElementById('Cart-Drawer').classList.add('active');
              document.body.classList.add('open-cart');
              document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
              dispatchCustomEvent('cart-drawer:open');
            }
          });
        }

        if (!document.getElementById('Cart-Drawer')) {
          document.body.classList.remove('open-cc');
          window.location.href = window.theme?.routes?.cart_url || '/cart';
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      } else {
        window.location.href = window.theme?.routes?.cart_url || '/cart';
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.measureHeader();
      this.setupObservers();
      this.setupToggle();
      this.setupVariantSync();
    }
    measureHeader() {
      // Set --header-height so the sticky bar sits below the navbar on mobile
      const header = document.querySelector('.header-section') || document.querySelector('header');
      if (header) {
        const h = header.offsetHeight;
        this.style.setProperty('--header-height', h + 'px');
      }
    }
    setupVariantSync() {
      // Safety net: listen for variant changes and update sticky button state
      document.addEventListener('product:variant-change', (e) => {
        const variant = e.detail ? e.detail.variant : null;
        const addBtn = this.querySelector('#AddToCartSticky');
        const btnText = addBtn ? addBtn.querySelector('.single-add-to-cart-button--text') : null;
        if (!addBtn || !btnText) return;
        if (!variant || !variant.available) {
          addBtn.setAttribute('disabled', 'disabled');
          addBtn.classList.add('sold-out');
          btnText.textContent = variant ? window.theme.variantStrings.soldOut : window.theme.variantStrings.unavailable;
        } else {
          addBtn.removeAttribute('disabled');
          addBtn.classList.remove('sold-out');
          const productForm = this.querySelector('product-form');
          const template = productForm ? productForm.closest('.product-form')?.getAttribute('template') : '';
          btnText.textContent = template?.includes('pre-order') ? window.theme.variantStrings.preOrder : window.theme.variantStrings.addToCart;
        }
      });
    }
    setupToggle() {
      const _this = this;
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if (!button || !content) return;

      if (this.animations_enabled) {
        // Get the natural height of the content
        content.style.display = 'block';
        content.style.height = 'auto';
        content.style.maxHeight = 'none'; // Override CSS max-height
        const naturalHeight = content.offsetHeight;
        content.style.height = '0px';
        content.style.overflow = 'hidden';

        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            _this.classList.add('is-open');
          },
          onReverseComplete: () => {
            _this.classList.remove('is-open');
          }
        });

        // Animate TO the natural height, not FROM
        tl.to(content, {
          height: naturalHeight,
          duration: 0.25,
          ease: 'power2.out'
        });

        button.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          tl.reversed() ? tl.play() : tl.reverse();
        });

        // Store timeline reference for collapsing from outside
        this._timeline = tl;
      } else {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          _this.classList.toggle('is-open');
        });
      }

      // Close on outside click (mobile UX)
      document.addEventListener('click', (e) => {
        if (!_this.classList.contains('is-open')) return;
        if (_this.contains(e.target)) return;
        this.collapseSticky();
      });
    }
    collapseSticky() {
      if (!this.classList.contains('is-open')) return;
      if (this._timeline) {
        if (!this._timeline.reversed()) this._timeline.reverse();
      } else {
        this.classList.remove('is-open');
      }
    }
    setupObservers() {
      let _this = this,
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');

      if (!form) return;

      /* ── ATC button observer ──
         Watch the inline Add-to-Cart button (small, fixed-height element).
         When it scrolls fully out of view upward → show sticky.
         When any part re-enters the viewport → hide sticky. */
      let atcButton = form.querySelector('.single-add-to-cart-button') || form.querySelector('[name="add"]');
      let observeTarget = atcButton || form;

      let formObserver = new IntersectionObserver(function (entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            _this.formPassed = false;
            _this.collapseSticky();
            _this.classList.remove('sticky--visible');
          } else {
            let rect = entry.boundingClientRect;
            if (rect.bottom < 0) {
              _this.formPassed = true;
              _this.classList.add('sticky--visible');
            }
          }
        });
      }, {
        threshold: 0
      });

      /* ── Footer observer ──
         Hide sticky when the footer comes into view. */
      let footerObserver = new IntersectionObserver(function (entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            _this.collapseSticky();
            _this.classList.remove('sticky--visible');
          } else if (!entry.isIntersecting && _this.formPassed) {
            _this.classList.add('sticky--visible');
          }
        });
      }, {
        threshold: 0
      });

      _this.formPassed = false;
      formObserver.observe(observeTarget);
      if (footer) footerObserver.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}